import { CollaboTitleText } from 'src/components/Global/Text/TitleText'
import { InvestmentAmountCard } from 'src/components/Global/Cards/Cards'

import { StatusUp } from 'src/assets'
import { InvestmentHeaderWrapper } from './investHeaderStyle'
import useUserData from 'src/hooks/useUserData'

const InvestmentHeader = () => {
  const USER_DATA = useUserData()

  return (
    <InvestmentHeaderWrapper>
      <CollaboTitleText>Investments</CollaboTitleText>
      <div className="saving-card">
        <img src={StatusUp} className="increase-icon" alt="" />
        <div className="card-title">
          <p>Total Investment</p>
          <h2>{USER_DATA.user.accounts.total_investment}</h2>
        </div>
      </div>
    </InvestmentHeaderWrapper>
  )
}
export { InvestmentHeader }
